/**
 * Types for LinkedIn outbound delivery state, as returned by the browser
 * extension delivery-status endpoint.
 */

export type LinkedInDeliveryStatus =
  | 'queued'
  | 'claimed'
  | 'sent'
  | 'failed'
  | 'expired';

// Statuses not in this set are treated as terminal for polling purposes.
// Update this set whenever a status is added to or removed from LinkedInDeliveryStatus.
export const NON_TERMINAL_STATUSES: ReadonlySet<LinkedInDeliveryStatus> =
  new Set<LinkedInDeliveryStatus>(['queued', 'claimed']);

export interface LinkedInDeliveryState {
  proposed_action_id: number;
  status: LinkedInDeliveryStatus;
  sent_at: string | null;
  last_error: string;
  expires_at: string;
  needs_attention: boolean;
}
